/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./permisos.component";
var styles_PermisosComponent = [];
var RenderType_PermisosComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_PermisosComponent, data: {} });
export { RenderType_PermisosComponent as RenderType_PermisosComponent };
export function View_PermisosComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, [" permisos works!\n"]))], null, null); }
export function View_PermisosComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-permisos", [], null, null, null, View_PermisosComponent_0, RenderType_PermisosComponent)), i0.ɵdid(1, 114688, null, 0, i1.PermisosComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var PermisosComponentNgFactory = i0.ɵccf("app-permisos", i1.PermisosComponent, View_PermisosComponent_Host_0, {}, {}, []);
export { PermisosComponentNgFactory as PermisosComponentNgFactory };
